import React, { ReactNode } from 'react';

type Props = {
  date: string;
  fallback?: ReactNode;
};

const DateView: React.FC<Props> = ({ date, fallback = '' }) => {
  const d = new Date(date);

  const dd = d
    .getDate()
    .toString()
    .padStart(2, '0');
  const mm = `${d.getMonth() + 1}`.padStart(2, '0');
  const yyyy = d.getFullYear();

  return <>{date ? <> {`${mm}/${dd}/${yyyy}`} </> : fallback}</>;
};

export default DateView;
